import "../../assets/MessageHeader.css";
import { jsxs as n, jsx as e, Fragment as d } from "react/jsx-runtime";
import { c as f } from "../../index-0371017d.js";
import { ParticipantInfo as _ } from "../ParticipantInfo/ParticipantInfo.js";
import { BackArrow as k } from "../icons/BackArrow.js";
const h = "_messageHeader_1f90o_1", u = "_avatar_1f90o_11", v = "_backButton_1f90o_17", x = "_inactiveText_1f90o_21", g = "_linkText_1f90o_25", N = "_chartLink_1f90o_29", a = {
  messageHeader: h,
  avatar: u,
  backButton: v,
  inactiveText: x,
  linkText: g,
  chartLink: N
}, L = ({
  participant: t,
  gotoPatientChart: s,
  gotoMessageHome: o,
  isInactive: c = !1,
  isPatientUi: r = !1,
  customClass: i
}) => {
  const l = () => c ? /* @__PURE__ */ e("div", { className: a.inactiveText, children: r ? `${t.firstName} is no longer part of your care team` : `${t.firstName} is no longer a client` }) : !r && typeof s == "function" ? /* @__PURE__ */ e(
    "a",
    {
      className: a.chartLink,
      "data-testid": "message-header-patient-chart-link",
      onClick: () => s ? s(t.uuid) : null,
      children: "View client chart →"
    }
  ) : /* @__PURE__ */ e(d, {}), m = f(a.messageHeader, i);
  return /* @__PURE__ */ n("div", { className: m, children: [
    /* @__PURE__ */ n("div", { className: a.avatar, children: [
      /* @__PURE__ */ e(
        "div",
        {
          className: a.backButton,
          onClick: () => o(),
          "data-testid": "message-header-back-button",
          children: /* @__PURE__ */ e(k, { stroke: "#262626", width: 14, height: 14 })
        }
      ),
      /* @__PURE__ */ e(_, { ...t, format: "horizontal", size: "small" })
    ] }),
    l()
  ] });
};
export {
  L as MessageHeader
};
